// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2gEEP","buttons":"RemoveExpirationActionButtons_buttons__3TM0i"};